import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@config/config";

const fetchSearchOptions = async () => {
    const res = await axios.get(`${API_BASE_URL}/search`);
    const data = Array.isArray(res.data?.data) ? res.data.data : [];
    return data.map((item) => ({
        ...item,
        label: `${item.name} (${item.type})`,
        value: item.name,
        url: item.link_url,
    }));
};

export const useSearchOptions = (enabled = false) => {
    const { data, isLoading } = useQuery({
        queryKey: ["searchOptions"],
        queryFn: fetchSearchOptions,
        enabled,
        staleTime: Infinity,
    });

    return {
        searchOptions: data ?? [],
        isSearchOptionsLoading: isLoading,
    };
};
